<div class="flex container">
  <div class="flex one">
    <div class="flex half-1" style="position: relative;">
      <img src={{MileleLogoPath}} class="milele-logo" alt="logo" (click)="navHome()" />

      <div class="flex power-small"> {{ powerdByText }} </div>
    </div>

    <div class="flex half-2">
    </div>
  </div>

  <div class="flex two">
    <img src={{logoPath}} class="logo" alt="logo" />
  </div>

  <div class="content-loading" *ngIf="showContinuePopup">
    <div class="flex column resume-content">
      <div class="flex resume-row bot">
        <div class="flex warn">
          <img src={{warnPath}} class="warn-img" alt="warning" />
        </div>
        <span class="resume-title">Resume Previous Session</span>
      </div>

      <div class="flex column width-100 center">
        <div class="flex resume-row"
          style="padding: 5%; border: 0.1px solid lightgray; box-sizing: border-box; border-radius: 5px; width: 90%;">
          <!-- <img src={{arrowPath}} class="arrow-img" alt="arrow-right" /> -->

          <span style="font-weight: bolder; color: #B68400;">{{'Step '}}</span>
          <div class="resume-active">
            {{estateDataHolder.activeTab }}
          </div>

          <div style="width: 1px; height: 40px; background-color: #B68400; margin-left: 15px; margin-right: 15px;">
          </div>
          <span class="resume-text">{{ resumeActiveTextEstate }}</span>
        </div>

        <div class="flex column stk-div">
          <div class="flex putton green" (click)="resumeEstate()">
            {{ 'Continue' }}

          </div>

          <div class="flex putton red" (click)="resumeEstate(false)">
            {{ 'New Session' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Resume -->
  <div class="content-loading" *ngIf="showResumePopup">
    <div class="flex column resume-content">
      <div class="flex resume-row bot">
        <span class="resume-title">Enter OTP</span>
      </div>
      <div class="flex resume-row">
        <span class="resume-text">
          {{ 'Use the OTP provided in your email address (' +otpEmail +' ) to retrieve your saved progress:' }}
        </span>
      </div>

      <form [formGroup]="otpForm">
        <div
          style="width: 100%; display: flex; align-items: center; justify-content: center; margin-bottom: 30px; margin-top: 30px;">
          <ng-otp-input (onInputChange)="onOtpChange($event)"
            [config]="{length:6, allowNumbersOnly: true}"></ng-otp-input>
        </div>
      </form>

      <div class="flex resume-row buttons">
        <div class="flex putton rend" (click)="closeOTPPopup()">
          {{ 'Close' }}
        </div>

        <div class="flex putton ngreen" [ngClass]="{'ngreen-loading': otpLoading}" (click)="verifyOTP()"
          *ngIf="otpReady">
          {{ otpLoading ? 'Verifying' : 'Verify' }}
          <span class="spin-otp" *ngIf="otpLoading">
            <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4"></mat-progress-spinner>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="flex content-holder">
    <div class="flex content-wrapper">
      <div class="content">
        <div class="subcontent">
          <div class="formal">
            <h1 class="blue" style="margin-top: 40px;">Create your Plan</h1>
            <p class="lead local">
              ICEA LION Trust helps you have a solid plan to secure your loved ones' future.
              To proceed, select the plan you wish to set up.
            </p>
            <div class="row settlor"
              style="display: flex; align-items: center; justify-content: center; margin-top: 10px;">
              <app-radios style="display: flex; width: 100%; align-items: center; justify-content: center;"
                labelOptionA="Private Trust Creation" labelOptionB="Will Creation"
                (valueChange)="onOptionChange($event)">
              </app-radios>
            </div>

            <div style="display: flex; width: 100%; align-items: center; justify-content: center; margin-top: 30px;">
              <div class="flex column disclaimer" style="height: fit-content; padding-top: 16px; padding-bottom: 16px;">
                {{disclaimer}}
                <span style="color: rgb(160, 9, 9); margin-top: 8px; font-size: small;">
                  Completing this online application will take approximately <strong
                    style="font-weight: 900; color: rgb(160, 9, 9) !important;">20 minutes</strong>.<br>Please ensure
                  you have all required details ready before you begin.
                </span>
              </div>
            </div>
          </div>

          <!-- BOTTOM OF FORM  iSwear.value === true -->
          <app-form-bottom style="width: 100%;" [text]="'Next'" [formValid]="true" [showContinue]="'false'"
            [buttonClickHandler]="navEstate.bind(this)">
          </app-form-bottom>
        </div>
      </div>
    </div>
  </div>

</div>